import { useEffect, useRef, useState } from "react";
import { Button } from "../button/button";
import { CheckMarkIcon, EditIcon } from "../../assets/icons";
import { Retractable } from "../retractable/retractable";
import classNames from "classnames";

import styles from "./editableHeader.module.css";

export const EditableHeader = ({ title = "", onEdit = () => { }, children }) => {
    const [titleState, setTitleState] = useState(title);
    const [editing, setEditing] = useState(false);
    const textareaRef = useRef(null);

    useEffect(() => {
        setTitleState(title);
    }, [title]);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        }
    }, [titleState]);

    return (
        <header className={classNames(styles.header, { [styles.active]: editing, [styles.error]: editing && (titleState.length <= 1 || titleState.length >= 255) })}>
            <div className={styles.top}>
                <div style={{ alignItems: "center", display: "flex", height: "100%", minWidth: "0px" }}>
                    <textarea
                        className={styles.header_title}
                        value={titleState}
                        onChange={(e) => setTitleState(e.target.value.replaceAll("\n", ""))}
                        disabled={!editing}
                        ref={textareaRef}
                        rows={1}
                    />
                </div>

                <Button
                    className={styles.edit_button}
                    icon={editing ? <CheckMarkIcon /> : <EditIcon />}
                    type={editing ? "primary" : "secondary"}
                    onClick={() => {
                        if (editing) {
                            if (titleState.length > 1 && titleState.length < 255) {
                                onEdit(titleState);
                                setEditing(false);
                            }
                        } else {
                            setEditing(true);
                        }
                        textareaRef.current.focus();
                    }}
                />
            </div>

            {
                !!children &&
                <Retractable style={{ paddingTop: editing ? "10px" : "0" }} active={editing}>
                    {children}
                </Retractable>
            }
        </header>
    );
}
